const GENE_COLORS = {
  "5UTR" :  {light_color_1: 'rgb(154, 154, 154)', light_color_2: 'rgb(108, 108, 108)',
    light_color_3: 'rgb(211, 211, 211)', light_color_4: 'rgb(176, 176, 176)',
    dark_color_1: 'rgb(106, 106, 106)', dark_color_2: 'rgb(152, 152, 152)',
    dark_color_3: 'rgb(63, 63, 63)', dark_color_4: 'rgb(82, 82, 82)',
    label: "5'UTR", shortLabel: "5'UTR",  classLabel: 'other-5utr'},
  "ORF1a":  {light_color_1: 'rgb(129, 57, 93)', light_color_2: 'rgb(129, 57, 93)',
    light_color_3: 'rgb(203, 187, 203)', light_color_4: 'rgb(158, 80, 116)',
    dark_color_1: 'rgb(145, 67, 103)', dark_color_2: 'rgb(194, 113, 149)',
    dark_color_3: 'rgb(63, 38, 51)', dark_color_4: 'rgb(117, 43, 81)',
    label: 'ORF1a', shortLabel: 'ORF1a',  classLabel: 'gene-1a'},
  "ORF1b":  {light_color_1: 'rgb(129, 57, 93)', light_color_2: 'rgb(129, 57, 93)',
    light_color_3: 'rgb(203, 187, 203)', light_color_4: 'rgb(158, 80, 116)',
    dark_color_1: 'rgb(145, 67, 103)', dark_color_2: 'rgb(194, 113, 149)',
    dark_color_3: 'rgb(63, 38, 51)', dark_color_4: 'rgb(117, 43, 81)',
    label: 'ORF1b', shortLabel: 'ORF1b',  classLabel: 'gene-1b'},
  "S":      {light_color_1: 'rgb(125, 117, 202)', light_color_2: 'rgb(125, 117, 202)',
    light_color_3: 'rgb(182, 192, 227)', light_color_4: 'rgb(150, 143, 231)',
    dark_color_1: 'rgb(143, 130, 217)', dark_color_2: 'rgb(190, 176, 255)',
    dark_color_3: 'rgb(65, 62, 93)', dark_color_4: 'rgb(114, 104, 188)',
    label: 'Spike', shortLabel: 'Spike',  classLabel: 'gene-spike'},
  "ORF3a":  {light_color_1: 'rgb(148, 171, 74)', light_color_2: 'rgb(148, 171, 74)',
    light_color_3: 'rgb(188, 208, 188)', light_color_4: 'rgb(173, 199, 102)',
    dark_color_1: 'rgb(168, 189, 87)', dark_color_2: 'rgb(215, 238, 135)',
    dark_color_3: 'rgb(77, 84, 49)', dark_color_4: 'rgb(138, 160, 62)',
    label: 'ORF3a', shortLabel: '3a',  classLabel: 'gene-3a'},
  "E":      {light_color_1: 'rgb(21, 123, 106)', light_color_2: 'rgb(21, 123, 106)',
    light_color_3: 'rgb(161, 197, 192)', light_color_4: 'rgb(54, 149, 132)',
    dark_color_1: 'rgb(46, 135, 115)', dark_color_2: 'rgb(94, 184, 163)',
    dark_color_3: 'rgb(32, 63, 57)', dark_color_4: 'rgb(0, 110, 92)',
    label: 'E', shortLabel: 'E',  classLabel: 'gene-e'},
  "M":      {light_color_1: 'rgb(21, 123, 106)', light_color_2: 'rgb(21, 123, 106)',
    light_color_3: 'rgb(161, 197, 192)', light_color_4: 'rgb(54, 149, 132)',
    dark_color_1: 'rgb(46, 135, 115)', dark_color_2: 'rgb(94, 184, 163)',
    dark_color_3: 'rgb(32, 63, 57)', dark_color_4: 'rgb(0, 110, 92)',
    label: 'M', shortLabel: 'M',  classLabel: 'gene-m'},
  "ORF6":   {light_color_1: 'rgb(210, 141, 70)', light_color_2: 'rgb(210, 141, 70)',
    light_color_3: 'rgb(211, 195, 173)', light_color_4: 'rgb(239, 167, 97)',
    dark_color_1: 'rgb(252, 153, 79)', dark_color_2: 'rgb(255, 202, 127)',
    dark_color_3: 'rgb(103, 73, 47)', dark_color_4: 'rgb(220, 127, 56)',
    label: 'ORF6', shortLabel: '6',  classLabel: 'gene-6'},
  "ORF7a":  {light_color_1: 'rgb(210, 141, 70)', light_color_2: 'rgb(210, 141, 70)',
    light_color_3: 'rgb(211, 195, 173)', light_color_4: 'rgb(239, 167, 97)',
    dark_color_1: 'rgb(252, 153, 79)', dark_color_2: 'rgb(255, 202, 127)',
    dark_color_3: 'rgb(103, 73, 47)', dark_color_4: 'rgb(220, 127, 56)',
    label: 'ORF7a', shortLabel: '7a',  classLabel: 'gene-7a'},
  "ORF7b":  {light_color_1: 'rgb(207, 68, 49)', light_color_2: 'rgb(151, 6, 11)',
    light_color_3: 'rgb(215, 178, 161)', light_color_4: 'rgb(237, 97, 74)',
    dark_color_1: 'rgb(237, 79, 56)', dark_color_2: 'rgb(255, 131, 101)',
    dark_color_3: 'rgb(94, 44, 37)', dark_color_4: 'rgb(204, 50, 35)',
    label: 'ORF7b', shortLabel: '7b',  classLabel: 'gene-7b'},
  "ORF8":   {light_color_1: 'rgb(210, 141, 70)', light_color_2: 'rgb(157, 95, 27)',
    light_color_3: 'rgb(211, 195, 173)', light_color_4: 'rgb(239, 167, 97)',
    dark_color_1: 'rgb(252, 153, 79)', dark_color_2: 'rgb(255, 202, 127)',
    dark_color_3: 'rgb(103, 73, 47)', dark_color_4: 'rgb(220, 127, 56)',
    label: 'ORF8', shortLabel: '8',  classLabel: 'gene-8'},
  "N":      {light_color_1: 'rgb(21, 123, 106)', light_color_2: 'rgb(21, 123, 106)',
    light_color_3: 'rgb(161, 197, 192)', light_color_4: 'rgb(54, 149, 132)',
    dark_color_1: 'rgb(46, 135, 115)', dark_color_2: 'rgb(94, 184, 163)',
    dark_color_3: 'rgb(32, 63, 57)', dark_color_4: 'rgb(0, 110, 92)',
    label: 'N', shortLabel: 'N',  classLabel: 'gene-n'},
  "ORF9b":  {light_color_1: 'rgb(21, 123, 106)', light_color_2: 'rgb(21, 123, 106)',
    light_color_3: 'rgb(161, 197, 192)', light_color_4: 'rgb(54, 149, 132)',
    dark_color_1: 'rgb(46, 135, 115)', dark_color_2: 'rgb(94, 184, 163)',
    dark_color_3: 'rgb(32, 63, 57)', dark_color_4: 'rgb(0, 110, 92)',
    label: 'ORF9b', shortLabel: '9b',  classLabel: 'gene-9b'},
  "ORF10":  {light_color_1: 'rgb(21, 123, 106)', light_color_2: 'rgb(21, 123, 106)',
    light_color_3: 'rgb(161, 197, 192)', light_color_4: 'rgb(54, 149, 132)',
    dark_color_1: 'rgb(46, 135, 115)', dark_color_2: 'rgb(94, 184, 163)',
    dark_color_3: 'rgb(32, 63, 57)', dark_color_4: 'rgb(0, 110, 92)',
    label: 'ORF10', shortLabel: '10',  classLabel: 'gene-10'},
  "3UTR":   {light_color_1: 'rgb(154, 154, 154)', light_color_2: 'rgb(154, 154, 154)',
    light_color_3: 'rgb(211, 211, 211)', light_color_4: 'rgb(176, 176, 176)',
    dark_color_1: 'rgb(106, 106, 106)', dark_color_2: 'rgb(152, 152, 152)',
    dark_color_3: 'rgb(63, 63, 63)', dark_color_4: 'rgb(82, 82, 82)',
    label: "3'UTR", shortLabel: "3'",  classLabel: 'other-3utr'},
  "Non-coding region" : {light_color_1: 'rgb(154, 154, 154)', light_color_2: 'rgb(154, 154, 154)',
    light_color_3: 'rgb(211, 211, 211)', light_color_4: 'rgb(176, 176, 176)',
    dark_color_1: 'rgb(106, 106, 106)', dark_color_2: 'rgb(152, 152, 152)',
    dark_color_3: 'rgb(63, 63, 63)', dark_color_4: 'rgb(82, 82, 82)',
    label: 'Noncoding', shortLabel: 'Noncoding',  classLabel: 'other-noncoding'}
}




//const LIGHT_BG = 'rgb(255, 255, 255)';

const LIGHT_GENE_BG = 'rgb(235, 235, 235)'//'rgb(230, 230, 230)';
const LIGHT_GENE_BG_BACK = 'rgb(251, 251, 251)';
const LIGHT_GENE_BG_MID = 'rgb(246, 246, 246)';

const LIGHT_LABEL = 'rgb(106, 106, 106)';
const LIGHT_VARIANT_NAME_COLOR = 'rgb(70, 70, 70)';
//const LIGHT_ACCENT_COLOR = 'rgb(0, 153, 176)';

const LIGHT_MUTATION_POINTER_COLOR = 'rgb(170, 170, 170)';

//const DARK_BG = 'rgb(20, 20, 20)';

const DARK_GENE_BG = 'rgb(30, 30, 30)';
const DARK_GENE_BG_BACK = 'rgb(19, 19, 19)';
const DARK_GENE_BG_MID = 'rgb(24, 24, 24)';

const DARK_LABEL = 'rgb(149, 149, 149)';
const DARK_VARIANT_NAME_COLOR = 'rgb(176, 176, 176)';
//const DARK_ACCENT_COLOR = 'rgb(0, 128, 151)';

const DARK_MUTATION_POINTER_COLOR = 'rgb(82, 82, 82)';


const VARIANT_FONT = '700 9px "frank-new"';
const GENE_FONT = '900 9px "frank-new"';
const MUTATION_FONT = '700 9px "frank-new"';
const PCT_FONT = '700 12px "frank-new"';
const COUNT_FONT = '700 9px "frank-new"';
const BLOCK_FONT = '900 12px "frank-new"';

const SEQUENCE_TICK_STROKE_WEIGHT = 1.5;
const MUTATION_TICK_STROKE_WEIGHT = 3;
const MUTATION_BLOCK_STROKE_WEIGHT = 1;

const ARC_RANGE_DESKTOP = 0.9;
const ARC_RANGE_MOBILE = 0.75;
// const VARIANT_MARGIN = 0.024;
// const OUTER_MARGIN = 0.077;
// const BAND_WIDTH = 0.069;
const VARIANT_MARGIN = 0.009;
const OUTER_MARGIN = 0.077;
const BAND_WIDTH = 0.1;
const LABEL_RADIUS_MARGIN = 8;

const GENE_Y = 150;
const MUTATION_LABEL_Y = 209;
const TOP_MARGIN = 220;
const LEFT_MARGIN = 60;//100;
const RIGHT_MARGIN = 30;//50;
const VARIANT_LABEL_XPOS = LEFT_MARGIN - 10;//- 15;

const HORIZ_BAND_WIDTH = 30;
const HORIZ_BAND_MARGIN = 10;
const DETAIL_BOX_TOP_GAP = HORIZ_BAND_MARGIN * 2;

const MUTATION_LABEL_PUSH_BACK_OPACITY = 0.4;

// these are suffixes that make strings like 'dark_color_1' , light_color_2
const CALLOUT_COLOR_NUM = '2',
  PUSHBACK_COLOR_NUM = '3',
  UNIFORM_COLOR = '1';


const RADIAL_SEQUENCE_GENE_LABEL_COLOR_NUM = '4';
const RADIAL_MUTATION_GENE_LABEL_COLOR_NUM = '4';

const SEQ_MARGIN_HORIZ = 15;
const MUT_MARGIN_HORIZ = 20;//30;
const MUT_MARGIN_HORIZ_BLOCK = 10;
const SEQ_MARGIN_RADIAL = 0.015;
const MUT_MARGIN_RADIAL = 0.08;

const BLOCK_SEPARATOR_WEIGHT = 2;
const MIN_WIDTH_FOR_LETTER = 15;

const MIN_GENE_WIDTH = 60;

const MARKER_HT_EXTRA = 115;
// const PREVALENCE_ZERO_THRESHOLD = 0.005; /* in the range 0-1, not 0-100 */
const PREVALENCE_LETTER_THRESHOLD = .01; /* in the range 0-1, not 0-100 */

/*
the number of entries here needs to match the
number of entries in PREVALENCE_COLORS_LIGHTMODE
and PREVALENCE_COLORS_DARKMODE, and the
last entry needs to be at least 1.0
*/
const PREVALENCE_COLORS_CONTROL_PCTS = [
  // 0.005,
  // 0.25,//0.5,
  // 0.75,//0.9,
  // 1.0
  0.005,
  0.5,
  0.9,
  1.0
];
//if lerpColor
// const PREVALENCE_COLOR_ZERO_LIGHTMODE = [231, 243, 247];
// const PREVALENCE_COLOR_LOW_LIGHTMODE = [126, 241, 255];
// const PREVALENCE_COLOR_HIGH_LIGHTMODE = [226, 109, 0];
//if lerpHSL
const PREVALENCE_COLOR_ZERO_LIGHTMODE = [236, 240, 245];//[200, 219, 221];
// const PREVALENCE_COLOR_LOW_LIGHTMODE = [158, 171, 148];
// const PREVALENCE_COLOR_HIGH_LIGHTMODE = [194, 113, 177];
const PREVALENCE_COLORS_LIGHTMODE = [
  // grey to @day-accent blue
  [236, 240, 245],
  [203, 210, 220],
  [65, 152, 173],
  [12, 114, 147]
  // blue to red
  // [148, 175, 169],
  // [120, 163, 177],
  // [165, 114, 173],
  // [151, 65, 122]
];


//
const PREVALENCE_COLOR_ZERO_DARKMODE = [27,27,27];
// const PREVALENCE_COLOR_LOW_DARKMODE = [182, 192, 227];
// const PREVALENCE_COLOR_HIGH_DARKMODE = [237, 79, 56];
const PREVALENCE_COLORS_DARKMODE = [
  [182, 192, 227],
  [237, 79, 56],
  [79, 79, 237],
  [79, 79, 237]];

const GENE_LABEL_WIDTH = 20;
const MAX_BLOCK_WIDTH = 20;

const TAU = Math.PI * 2;
const TEXT_ANGLE = TAU * 0.83;

const HIGHLIGHT_BORDER = 4;
const GENE_MARKER_OFFSET = 10;

export { GENE_COLORS, LIGHT_GENE_BG, LIGHT_GENE_BG_BACK, LIGHT_GENE_BG_MID,
  LIGHT_LABEL, LIGHT_VARIANT_NAME_COLOR, LIGHT_MUTATION_POINTER_COLOR,
  DARK_GENE_BG, DARK_GENE_BG_BACK, DARK_GENE_BG_MID,
  DARK_LABEL, DARK_VARIANT_NAME_COLOR, DARK_MUTATION_POINTER_COLOR,
  VARIANT_FONT, GENE_FONT, MUTATION_FONT, PCT_FONT, COUNT_FONT, BLOCK_FONT,
  SEQUENCE_TICK_STROKE_WEIGHT, MUTATION_TICK_STROKE_WEIGHT,
  MUTATION_BLOCK_STROKE_WEIGHT,
  BAND_WIDTH,  LABEL_RADIUS_MARGIN, VARIANT_MARGIN,
  SEQ_MARGIN_HORIZ, MUT_MARGIN_HORIZ, MUT_MARGIN_HORIZ_BLOCK,
  SEQ_MARGIN_RADIAL, MUT_MARGIN_RADIAL,
  MUTATION_LABEL_PUSH_BACK_OPACITY,
  ARC_RANGE_DESKTOP, ARC_RANGE_MOBILE,
  UNIFORM_COLOR, CALLOUT_COLOR_NUM, PUSHBACK_COLOR_NUM,
  RADIAL_SEQUENCE_GENE_LABEL_COLOR_NUM,
  RADIAL_MUTATION_GENE_LABEL_COLOR_NUM,
  HORIZ_BAND_WIDTH, HORIZ_BAND_MARGIN,
  TOP_MARGIN, GENE_Y, MUTATION_LABEL_Y,
  LEFT_MARGIN, VARIANT_LABEL_XPOS, RIGHT_MARGIN, OUTER_MARGIN, DETAIL_BOX_TOP_GAP,
  BLOCK_SEPARATOR_WEIGHT, MIN_WIDTH_FOR_LETTER, MIN_GENE_WIDTH,
  // PREVALENCE_ZERO_THRESHOLD,
  PREVALENCE_LETTER_THRESHOLD,

  PREVALENCE_COLORS_CONTROL_PCTS,
  PREVALENCE_COLOR_ZERO_LIGHTMODE, PREVALENCE_COLORS_LIGHTMODE,
  // PREVALENCE_COLOR_LOW_LIGHTMODE, PREVALENCE_COLOR_HIGH_LIGHTMODE,
  PREVALENCE_COLOR_ZERO_DARKMODE, PREVALENCE_COLORS_DARKMODE,
  // PREVALENCE_COLOR_LOW_DARKMODE, PREVALENCE_COLOR_HIGH_DARKMODE,
  MARKER_HT_EXTRA,  GENE_LABEL_WIDTH, MAX_BLOCK_WIDTH,
  TAU, TEXT_ANGLE, HIGHLIGHT_BORDER, GENE_MARKER_OFFSET

};
